var _Info, _CheckmarkCircle, _AlertTriangle, _CloseCircle;
import AlertTriangle from '@crehana/compass.icons.fill/AlertTriangle';
import CheckmarkCircle from '@crehana/compass.icons.fill/CheckmarkCircle';
import CloseCircle from '@crehana/compass.icons.fill/CloseCircle';
import Info from '@crehana/compass.icons.fill/Info';
import { jsx as _jsx } from "react/jsx-runtime";
export var ToastIcon = function ToastIcon(_ref) {
  var type = _ref.type;
  switch (type) {
    case 'informative':
      return _Info || (_Info = /*#__PURE__*/_jsx(Info, {
        size: 20,
        className: "tw-text-info-500 dark:tw-text-info-300"
      }));
    case 'success':
      return _CheckmarkCircle || (_CheckmarkCircle = /*#__PURE__*/_jsx(CheckmarkCircle, {
        size: 20,
        className: "tw-text-success-500 dark:tw-text-success-400"
      }));
    case 'warning':
      return _AlertTriangle || (_AlertTriangle = /*#__PURE__*/_jsx(AlertTriangle, {
        size: 20,
        className: "tw-text-on-hold-500 dark:tw-text-on-hold-300"
      }));
    case 'error':
      return _CloseCircle || (_CloseCircle = /*#__PURE__*/_jsx(CloseCircle, {
        size: 20,
        className: "tw-text-alert-500 dark:tw-text-alert-300"
      }));
    default:
      return null;
  }
};